<template>
  <div class="pagina-step">
    <b-modal
      v-model="modalAjuda"
      id="bv-modal-notification"
      size="lg"
      hide-footer
      centered
    >
      <div v-html="modalTexto"></div>
    </b-modal>

    <div class="pagina-header">
      <div class="d-flex align-center justify-content-between">
        <p>
          <strong>
            Olá! Seja bem-vindo(a) ao simulador do Cofinanciamento Federal da
            APS instituído pela Portaria nº 3493 de 10 de abril de 2024.</strong
          >
        </p>
        <i
          class="icofont-info-circle"
          @click="modalAjuda = true"
          style="cursor: pointer; font-size: 20px"
        ></i>
      </div>

      <p>
        Este simulador foi desenvolvido para ajudá-lo(a) a entender melhor o
        cofinanciamento federal da APS, permitindo que você analise os dados do
        seu município em comparação com o modelo anterior e explore os
        diferentes cenários de desempenho (REGULAR, SUFICIENTE, BOM ou ÓTIMO)
        que podem ser alcançados com a nova metodologia.
      </p>
      <p>
        A precisão e a confiabilidade das informações apresentadas neste
        simulador dependem dos dados que você fornecer. Por isso, recomenda-se
        atenção máxima ao inserir essas informações.
      </p>
    </div>

    <div class="container-form">
      <ValidationObserver ref="observer" class="row">
        <div class="col-md-4 col-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="">
              <vue-select
                :options="estados"
                label="uf"
                placeholder="ESTADO"
                @input="onChangeEstados"
                v-model="form.estado"
                class="vue-select-estado"
              >
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-8 col-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="">
              <vue-select
                :options="cidades"
                label="no_municipio"
                placeholder="CIDADE"
                v-model="form.cidade"
                class="vue-select-cidade"
                :loading="loading"
              >
                <template slot="option" slot-scope="option">
                  {{ option.no_municipio }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-12 col-12 mt-4">
          <validation-provider
            v-slot="{ errors }"
            rules="required|email"
            ref="validationEmail"
          >
            <div>
              <input
                name="email"
                v-model="form.email"
                class="form-control"
                placeholder="SEU E-MAIL"
                type="email"
              />
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
      </ValidationObserver>
    </div>
    <div class="container-buttons">
      <button type="button" @click="voltar">Voltar</button>
      <button @click="proximo">
        Avançar
        <b-spinner
          label="Spinning"
          small
          variant="white"
          v-if="loading"
        ></b-spinner>
      </button>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import { optionsPortePopulacional, optionsIed, infoHtml } from './utils.js'

export default {
  components: {
    PulseLoader,
    'vue-select': VueSelect,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    dados: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalAjuda: true,
      modalTexto: infoHtml,
      form: {
        estado: '',
        cidade: '',
        email: '',
      },
      estados: [
        { uf: 'AC' },
        { uf: 'AL' },
        { uf: 'AP' },
        { uf: 'AM' },
        { uf: 'BA' },
        { uf: 'CE' },
        { uf: 'DF' },
        { uf: 'ES' },
        { uf: 'GO' },
        { uf: 'MA' },
        { uf: 'MT' },
        { uf: 'MS' },
        { uf: 'MG' },
        { uf: 'PA' },
        { uf: 'PB' },
        { uf: 'PR' },
        { uf: 'PE' },
        { uf: 'PI' },
        { uf: 'RJ' },
        { uf: 'RN' },
        { uf: 'RS' },
        { uf: 'RO' },
        { uf: 'RR' },
        { uf: 'SC' },
        { uf: 'SP' },
        { uf: 'SE' },
        { uf: 'TO' },
      ],
      loading: false,
      cidades: [],
    }
  },
  mounted() {
    if (this.dados?.etapa1 !== null) {
      const etapa1 = this.dados?.etapa1
      this.form.estado = etapa1.estado
      this.form.cidade = etapa1.cidade
      this.form.email = etapa1.email
    }
  },
  methods: {
    onChangeEstados(event) {
      if (event === null) {
        return
      }
      this.loading = true
      this.limpaCampos()
      let estado = event.uf
      this.$apiPublic
        .get('/cidades-por-uf/' + estado)
        .then((response) => {
          this.cidades = response.data
          this.loading = false
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    limpaCampos() {
      this.cidade = ''
      this.disabledInput = false
    },
    salvarDados() {
      this.$emit('dados-etapa', { etapa: 'etapa1', dados: this.form })
    },
    voltar() {
      this.$router.push('/')
    },
    proximo() {
      this.$refs.observer.validate().then(async (success) => {
        if (success) {
          try {
            this.loading = true
            const user = await this.$apiPublic.get(
              `/cofinanciamento-2024/usuario/${this.form.cidade.co_ibge}/${this.form.email}`
            )
            if (user.data) {
              this.dados.etapa2 = {
                nome: user.data.nome_contato,
                perfil: {
                  perfil: user.data.perfil,
                },
                email: this.form.email,
                whatsapp: user.data.whatsapp,
              }
            } else {
              this.dados.etapa2 = {
                nome: '',
                perfil: '',
                email: this.form.email,
                whatsapp: '',
              }

              const municipio = await this.$apiPublic.get(
                `/cofinanciamento-2024/municipio/${this.form.cidade.co_ibge}`
              )
              if (municipio.data) {
                // etapa 3
                const portePopulacional = optionsPortePopulacional.find(
                  (el) => {
                    const porte =
                      municipio.data.faixa_populacional.split('-')[0]
                    return el.value == porte
                  }
                )
                const ied = optionsIed.find((el) => {
                  return el.value == Number(municipio.data.ied)
                })
                this.dados.etapa3 = {
                  porte_populacional: {
                    ...portePopulacional,
                  },
                  ied: {
                    label: ied.label,
                    value: ied.value,
                  },
                }

                // etapa 4
                const servicos_pagamento = JSON.parse(
                  municipio.data.servicos_pagamento
                )
                this.dados.etapa4 = {
                  'eSF 40h': servicos_pagamento.esf_eap.qt_esf,
                  'eAP 30h': servicos_pagamento.esf_eap.eap_30,
                  'eAP 20h': servicos_pagamento.esf_eap.eap_20,
                  'eMulti Ampliada': servicos_pagamento.emulti.ampliada,
                  'eMulti Complementar': servicos_pagamento.emulti.complementar,
                  'eMulti Estratégica': servicos_pagamento.emulti.estrategica,
                  'eSB I - Comum': servicos_pagamento.sb.qt_40h_mod_1,
                  'eSB II - Comum': servicos_pagamento.sb.qt_40h_mod_2,
                  'eSB I- Quil/Assent': 0,
                  'eSB II- Quil/Assent': 0,
                }

                // etapa 6
                const ult_parc_previne = JSON.parse(
                  municipio.data.ult_parc_previne
                )
                if (ult_parc_previne != null) {
                  this.dados.etapa6 = {
                    capitacaoPonderada: ult_parc_previne.capit_ponderada,
                    indicadoresSaudeBucal: ult_parc_previne.desempenho_esb,
                    indicadoresSaudeNaHora: ult_parc_previne.saude_na_h,
                    informatizaAps: ult_parc_previne.informatiza_aps,
                    pagamentoCriterioPopulacional: ult_parc_previne.per_capita,
                    pagamentoDesempenho: ult_parc_previne.desempenho_esf_eap,
                  }
                }

                // etapa 7
                this.dados.etapa7 = {}
                this.dados.etapa7.medicos =
                  servicos_pagamento.esf_eap.mm_coparticipacao >= 0
                    ? servicos_pagamento.esf_eap.mm_coparticipacao
                    : 0

                // etapa 8
                this.dados.etapa8 = {}
                this.dados.etapa8.equipes = [
                  {
                    label: 'Equipes de Saúde Bucal (eSB)',
                    value: servicos_pagamento.sb.cust_esb,
                    key: 'equipes_saude_bucal',
                  },
                  {
                    label: 'Unidades Odontológicas Móveis (UOM)',
                    value: servicos_pagamento.sb.val_custeio_uom,
                    key: 'uom',
                  },
                  {
                    label: 'Centros de Especialidades Odontológicas (CEO)',
                    value: servicos_pagamento.sb.val_ceo_municipal,
                    key: 'ceo',
                  },
                  {
                    label: 'Laboratórios Regionais de Prótese Dentária (LRPD)',
                    value: servicos_pagamento.sb.val_lrpd_municipal,
                    key: 'lrpd',
                  },
                  {
                    label: 'Serviços de Especialidades em Saúde Bucal (SESB)',
                    value: servicos_pagamento.sb.val_sesb,
                    key: 'sesb',
                  },
                ]

                //etapa 9
                this.dados.etapa9 = {}
                this.dados.etapa9.equipes = [
                  {
                    label: 'Custeio por atendimento remoto na eMulti',
                    value: servicos_pagamento.emulti.man_at_remoto,
                    key: 'custeio_atendimento_remoto_emulti',
                  },
                  {
                    label: 'Custeio eMulti',
                    value: servicos_pagamento.emulti.cust_emulti,
                    key: 'custeio_emulti',
                  },
                ]
              }
            }
            this.salvarDados()
            this.$emit('proxima-etapa')
          } catch (error) {
            console.log(error)
          } finally {
            this.loading = false
          }
        } else {
          this.$toast.warning('Preencha os campos obrigatórios!', 'Erro:', {
            position: 'topRight',
          })
        }
      })
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
